import React from 'react';
import './vertical_nav_bar.scss';
import { Navbar, Nav } from 'react-bootstrap';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { NavLink } from 'react-router-dom';
import global from '../../store/global';
import { isDefined } from '../../utils/utils';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import variables from '../../assets/bootstrap/scss/_variables.scss';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import ClearIcon from '@material-ui/icons/Clear';

interface EnumNavBarItem {
  link: any;
  icon: string;
  itemTitle?: string;
}

interface EnumNavBarItems extends Array<EnumNavBarItem> {}

interface VerticalNavBarProps {
  itens: EnumNavBarItems;
}

const primaryColor = variables.primary;

const VerticalNavBar = ({ itens }: VerticalNavBarProps) => {
  const [isBarExtended, setIsBarExtended] = React.useState(false);

  const extendBar = () => {
    setIsBarExtended(!isBarExtended);
  };

  const infoTabs = itens;

  const useStyles = makeStyles((theme) => ({
    colorNavLink: {
      color: primaryColor
    }
  }));

  const classes = useStyles();

  return (
    <div className={`center-navbar float-left h-100 position-fixed`}>
      <Navbar
        collapseOnSelect
        expand='lg'
        className={`d-none d-lg-flex h-100 vertical-nav cursor-pointer ${
          isBarExtended ? `extendedMenu` : ''
        } `}
        onClick={extendBar}
      >
        <IconButton
          color='primary'
          className={`mt-4 ${isBarExtended ? `ml-4` : ''} `}
          size='small'
          aria-label='f3m'
          onClick={extendBar}
        >
          {isBarExtended ? <ClearIcon fontSize='large' /> : <MenuIcon fontSize='large' />}
        </IconButton>
        <Nav className='my-auto flex-column w-100'>
          {infoTabs.map((item) => (
            <NavLink
              className='nav-link-size d-flex w-100'
              onClick={(e) => {
                e.stopPropagation();
            }}
              isActive={(match, location) => {
                let res = false;
                if (!match) {
                  res = false;
                }
                if (
                  location.pathname === item.link ||
                  (location.pathname === '/PatientDetails' && item.link === '/wounds')
                ) {
                  res = true;
                }
                return res;
              }}
              activeClassName='selected'
              //to={item.link} com o link não permite bloquear o alterar de página em edição
              to={'#'}
            >
              {item.icon}
              {isBarExtended ? <ListItemIcon>{item.itemTitle}</ListItemIcon> : ''}
            </NavLink>
          ))}
        </Nav>
      </Navbar>
    </div>
  );
};

export default VerticalNavBar;
